import { render, staticRenderFns } from "./StatsCard2.vue?vue&type=template&id=561984e7&"
import script from "./StatsCard2.vue?vue&type=script&lang=js&"
export * from "./StatsCard2.vue?vue&type=script&lang=js&"
import style0 from "./StatsCard2.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports